<div class=" pl-0 pt-3 clasbtnaction" style="margin-left: 2%;margin-right: 2%;" >
  <div class="row  pt-2" style="display: flex;align-items: center;margin-bottom: 3%;">
    <div class="col-md-7 w-100">
      <p class="m-0 text-uppercase" style="font-size: 20px;color: #262756;font-weight: bold;">conducteurs</p>
      <small class="text-uppercase" style="font-size:15px;color: #959090;">Liste des conducteurs</small>
    </div>
  </div>
  <div class="col-12 w-100 pl-0">
    <div class="row w-100 m-0 mb-2">
      <div class="col-4">
        <div class="export-icons d-flex mb-2">
          <div class="icn-sec">
            <img (click)="exportExcel(exportDirective, 'xlsx')" src="assets/newImages/excel-svg.svg"
                 ngbTooltip="Expoter EXCEL"/>
          </div>
          <div class="icn-sec">
            <img (click)="exportTable()" src="assets/newImages/pdf-svg.svg" ngbTooltip="Expoter PDF"/>
          </div>
        </div>
      </div>

      <div class="col-6 w-100" style="text-align: right;margin-top: -20px;">
        <img placement="left" ngbTooltip="Ajouter Conducteur" src="assets/icons/add-user.svg"
          (click)="openDialogFileUpload2()" />
          <!-- <img placement="left" *ngIf="listItems.length >1"
          style="height: 87px; "
          ngbTooltip="Supprimer conducteur" src="assets/icons/icon-delete.svg"
          (click)="supprimerItems()" /> -->
      </div>
      <div class="col-2 w-100">
        <div
        *ngIf="listItems.length >1"
        (click)="supprimerItems('moreThanOne',null,null)"
          class="mat-form-field"
          placement="left"
          ngbTooltip="Supprimer plusieurs conducteurs"
          style="
            height: 63px;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 63px;
          "
        >
          <mat-icon style="font-size: 25px; padding: 0 !important"
            >delete_forever</mat-icon
          >
        </div>
      </div>
    </div>
    <hr style="border: 1px solid #e8e4e4;margin-top: 3%;">
    <div class="row" style="justify-content: space-between;">
      <div class="col-lg-3 w-100 col-md-6">
        <mat-form-field appearance="fill">
          <mat-label>Filtrer par GSM</mat-label>
          <input type="text" aria-label="Number" (keyup)="applyFilterer($event)" matInput
                 [(ngModel)]="searchbygsmnumber" #input id="getdt" name="getdt" value="{{ searchbygsmnumber}}"/>
        </mat-form-field>
      </div>
      <div class="col-lg-3 w-100 col-md-6">
        <mat-form-field appearance="fill">
          <mat-label>Filtrer par clé Dallas</mat-label>
          <input type="text" aria-label="Number" (keyup)="applyFilterer($event)" matInput [(ngModel)]="searchbydalass"
                 #input id="getdt" name="getdt" value="{{ searchbydalass}}"/>
        </mat-form-field>
      </div>
      <div class="col-lg-3 w-100 col-md-6">
        <mat-form-field appearance="fill">
          <mat-label>Filtrer par Nom</mat-label>
          <input type="text" aria-label="Number" (keyup)="applyFilterer($event)" matInput [(ngModel)]="searchbyname"
                 #input id="getdt" name="getdt" value="{{ searchbyname  }}"/>
        </mat-form-field>
      </div>
      <div class="col-lg-3 w-100 col-md-6" *ngIf="roleuser !=='User'">
        <mat-form-field appearance="fill">
          <mat-label>Filtrer par Compagnie</mat-label>
          <input matInput name="item_id" [(ngModel)]="searchbycompnid" #item_id="ngModel" placeholder="Item"
                 [matAutocomplete]="auto" required (ngModelChange)="applyFilter($event)">
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="valueMapper">
            <mat-option *ngFor="let item of filteredData" [value]="item.id" (click)="applyFilterer(item)">
              {{item.name}}
            </mat-option>
          </mat-autocomplete>
          <button mat-button matSuffix mat-icon-button>
            <mat-icon placement="left" ngbTooltip="Actualiser les données des conducteurs"
                      (click)="resetdatavihclcompny()">
              update
            </mat-icon>
          </button>
        </mat-form-field>
      </div>
    </div>
    <div class="row rowposition pt-3 pl-0   w-100" style="margin-top: 2%;">
      <div class="col-12 col-md-12 w-100 mx-3" style="    padding: 0px; ">
        <div class="example-container-contact mat-elevation-z8 ">
          <ngx-spinner *ngIf="driverSpinner ==true" bdColor="rgba(100,112,124,0.56)" size="medium" color="#233547"
                       type="ball-clip-rotate-multiple" [fullScreen]="false">
            <p style="color: white"></p>
          </ngx-spinner>
          <table #exportDirective="matTableExporter" matTableExporter mat-table [dataSource]="getDataSource()" matSort>
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox disabled (click)="$event.stopPropagation()"
                              (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
                              [aria-label]="checkboxLabel(row)">
                </mat-checkbox>
              </td>
            </ng-container>
            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> ID.</th>
              <td mat-cell *matCellDef="let element"> {{element?.id}} </td>
            </ng-container>
            <ng-container matColumnDef="last_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Nom</th>
              <td mat-cell *matCellDef="let element"> {{element?.last_name}} </td>
            </ng-container>
            <ng-container matColumnDef="first_name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Prénom</th>
              <td mat-cell *matCellDef="let element"> {{element?.first_name}} </td>
            </ng-container>
            <ng-container matColumnDef="company">
              <th mat-header-cell *matHeaderCellDef mat-sort-header
                  [ngStyle]="{'display':roleuser =='User' ? 'none' : '' }"> Compagnie
              </th>
              <td mat-cell *matCellDef="let element" [ngStyle]="{'display':roleuser =='User' ? 'none' : '' }">
                {{element?.company}} </td>
            </ng-container>
            <ng-container matColumnDef="gsm_number">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Numéro de téléphone</th>
              <td mat-cell *matCellDef="let element"> {{element?.gsm_number}} </td>
            </ng-container>
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Actions</th>
              <td mat-cell *matCellDef="let element">
                <img placement="left" *ngIf="roleuser !='User'" ngbTooltip="Détails conducteur"
                     src="assets/icons/Group-344.svg" (click)="getItemsbyClick(element)" [ngClass]="{disable:listItems.length>1}"/>

                <img placement="left" ngbTooltip="Modifier conducteur" src="assets/icons/icon-modifier.svg"
                  (click)="openDialogUpdate('oneItem',element.id,element.reseller_id ,element )" [ngClass]="{disable:listItems.length>1}"/>
                  <a
                     [ngStyle]="{'pointer-events': listItems.length >1 ? 'none' : 'all'
                    , 'opacity':listItems.length >1 ?'0.5' : '1'}"
                     >

                      <img placement="left"
                      ngbTooltip="Supprimer conducteur"
                      src="assets/icons/icon-delete.svg"
                      [ngClass]="{disable:listItems.length>1}"
                      (click)="supprimerItems('oneItem',element.id,element.reseller_id )"/>
                  </a>
              </td>
            </ng-container>
            <ng-container matColumnDef="date_birth">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Date de naissance</th>
              <td mat-cell *matCellDef="let element"> {{element?.date_birth}} </td>
            </ng-container>
            <ng-container matColumnDef="dallas">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Clé Dallas</th>
              <td mat-cell *matCellDef="let element"> {{element?.dallas}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selection.toggle(row)"
                (click)="getgogo()"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="12">
                Aucune donnée correspondante à votre recherche
              </td>
            </tr>
          </table>
          <mat-paginator #paginator [pageSize]="15"
                         [length]="dataSource?.data.length"
                         [pageSizeOptions]="[15, 30, 100]"
                         (page)="pageChanged($event)"
                         showFirstLastButtons>
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
  <div #myDiv (click)="exportDirective.exportTable('json')">
  </div>
  <table class="d-none" id="ExampleTable" #exportDirective="matTableExporter" matTableExporter mat-table
         [dataSource]="getDataSource()" matSort>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
      <td mat-cell *matCellDef="let element"> {{element?.id}} </td>
    </ng-container>


    <ng-container matColumnDef="last_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Nom</th>
      <td mat-cell *matCellDef="let element"> {{element?.last_name}} </td>
    </ng-container>


    <ng-container matColumnDef="first_name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Prénom</th>
      <td mat-cell *matCellDef="let element"> {{element?.first_name}} </td>
    </ng-container>


    <ng-container matColumnDef="company">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Compagnie</th>
      <td mat-cell *matCellDef="let element"> {{element?.company}} </td>
    </ng-container>


    <ng-container matColumnDef="gsm_number">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Numéro de téléphone</th>
      <td mat-cell *matCellDef="let element"> {{element?.gsm_number}} </td>
    </ng-container>


    <ng-container matColumnDef="date_birth">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Date de naissance</th>
      <td mat-cell *matCellDef="let element"> {{element?.date_birth}} </td>
    </ng-container>
    <ng-container matColumnDef="dallas">
      <th mat-header-cell *matHeaderCellDef mat-sort-header> Dallas</th>
      <td mat-cell *matCellDef="let element"> {{element?.dallas}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns2;"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns2;" (click)="selection.toggle(row)"></tr>

  </table>
